import {PaymentItem} from '../ReserveFacilityModel'
import {FacilityOption} from '../ResidentReserveFacilityFormComponents/RRFFReserveOptionInput'
import {COMMON_CONSTANTS} from '../../../CommonConstants'

interface CompareSet {
    firstKey: number,
    secondKey: number,
}

const compare = (a: CompareSet, b: CompareSet): number => {
    return (a.firstKey !== b.firstKey) ? (a.firstKey - b.firstKey) : (a.secondKey - b.secondKey)
}

export const comparePaymentItem = (item1: PaymentItem, item2: PaymentItem): number => {
    return compare(
        {firstKey: item1.displayOrder, secondKey: item1.id || COMMON_CONSTANTS.DISPLAY_ORDER_FACILITY},
        {firstKey: item2.displayOrder, secondKey: item2.id || COMMON_CONSTANTS.DISPLAY_ORDER_FACILITY},
    )
}

export const compareFacilityOption = (item1: FacilityOption, item2: FacilityOption): number => {
    return compare(
        {firstKey: item1.sortOrder, secondKey: item1.optionId},
        {firstKey: item2.sortOrder, secondKey: item2.optionId},
    )
}
